import firstContactForm from './firstContactForm';
import coreDataForm from './coreDataForm';
import importantDataForm from './importantDataForm';
import miscForm from './miscForm';
import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';
import { Setting } from '../../../common/types/settings';

const clientForms = (advisors: Setting[]): Form<Client>[] => {
  return [firstContactForm, coreDataForm(advisors), importantDataForm, miscForm];
};

export default clientForms;
